import debug from 'src/debug';
import i18n from 'src/i18n';
import {get} from 'lodash';

export default function () {
  let ecommerce = [
    {
      name: i18n.s('schema.orders'),
      path: '/admin/orders',
    },
    {
      name: i18n.s('schema.products'),
      path: '/admin/products',
    },
    {
      name: i18n.s('schema.coupons'),
      path: '/admin/coupons',
    },
  ];
  if (get(this, '$auth.role') === 'superadmin') {
    ecommerce.splice(1, 0,
      {
        name: i18n.s('schema.transactions'),
        path: '/admin/transactions',
      },
      {
        name: i18n.s('schema.payments'),
        path: '/admin/payments',
      },
    );
  }
  let members = [
    {
      name: i18n.s('schema.members'),
      path: '/admin/members',
    },
    {
      name: i18n.s('schema.caregivers'),
      path: '/admin/caregivers',
    },
    {
      name: i18n.s('schema.clients'),
      path: '/admin/clients',
    },
    {
      name: i18n.s('schema.subprofiles'),
      path: '/admin/subprofiles',
    },
  ];
  if (debug.DEBUG && get(this, '$auth.role') === 'superadmin') {
    members.push({
      name: i18n.fr('action.import_members'),
      path: '/admin/members/import',
    });
  }
  let links = [
    {
      name: i18n.s('menu.overview'),
      // icon: 'ti-panel',
      path: '/admin/overview',
    },
    {
      name: i18n.s('menu.members'),
      // icon: 'ti-user',
      collapsed: true,
      children: members,
    },
    {
      name: i18n.s('menu.appointments'),
      path: '/admin/appointments',
      // icon: 'ti-user',
      // collapsed: true,
      // children: [
      //   {
      //     name: i18n.s('schema.appointments'),
      //     path: '/admin/appointments',
      //   },
      //   {
      //     name: i18n.s('schema.feedbacks_admin'),
      //     path: '/admin/feedback-admin',
      //   },
      //   {
      //     name: i18n.s('schema.feedbacks_caregiver'),
      //     path: '/admin/feedback-caregiver',
      //   },
      //   {
      //     name: i18n.s('schema.feedbacks_client'),
      //     path: '/admin/feedback-client',
      //   },
      // ],
    },
    {
      name: i18n.s('menu.ecommerce'),
      // icon: 'ti-money',
      collapsed: true,
      children: ecommerce,
    },
    {
      name: i18n.s('menu.admin'),
      // icon: 'ti-user',
      path: '/admin/admins',
    },
    {
      name: i18n.s('menu.feedbacks'),
      // icon: 'ti-user',
      collapsed: true,
      children: [
        {
          name: i18n.fr('schema.feedbacks_admin_caregiver'),
          path: '/admin/feedback-admin-caregiver',
        },
        {
          name: i18n.fr('schema.feedbacks_admin_client'),
          path: '/admin/feedback-admin-client',
        },
        {
          name: i18n.fr('schema.feedbacks_caregiver'),
          path: '/admin/feedback-caregiver',
        },
        {
          name: i18n.fr('schema.feedbacks_client'),
          path: '/admin/feedback-client',
        },
      ],
    },
    {
      name: i18n.s('schema.services'),
      // icon: 'ti-package',
      collapsed: true,
      path: '/admin/services',
    },
    {
      name: i18n.s('schema.groups'),
      // icon: 'ti-user',
      collapsed: true,
      children: [
        {
          name: i18n.s('schema.groups'),
          path: '/admin/groups',
        },
        {
          name: i18n.s('schema.group_applications'),
          path: '/admin/group-applications',
        },
      ],
    },
    {
      name: i18n.s('schema.contents'),
      // icon: 'ti-list',
      collapsed: true,
      children: [
        {
          name: i18n.s('schema.content'),
          path: '/admin/contents',
        },
        // {
        //   name: i18n.s('schema.categories'),
        //   path: '/admin/categories',
        //   // hide: !debug.DEBUG, // todo: pending
        // },
        {
          name: i18n.s('schema.posts'),
          path: '/admin/posts',
          hide: !debug.DEBUG, // todo: staging
        },
      ],
    },
    {
      name: i18n.s('menu.notifications'),
      // icon: 'ti-bell',
      collapsed: true,
      children: [
        {
          name: i18n.s('menu.notifications'),
          path: '/admin/notifications',
        },
        {
          name: i18n.s('schema.systemnotifications'),
          path: '/admin/systemnotifications',
        },
        {
          name: i18n.s('schema.adminsendouts'),
          path: '/admin/sendouts',
        },
        {
          name: i18n.s('schema.emails'),
          path: '/admin/emails',
        },
      ],
    },
    {
      name: i18n.s('menu.systemconfigs'),
      // icon: 'ti-settings',
      collapsed: true,
      path: '/admin/systemconfigs',
    },
    {
      name: i18n.s('schema.logs'),
      path: '/admin/logs',
    },
    {
      name: i18n.s('action.logout'),
      // icon: 'ti-arrow-left',
      path: '/logout',
    },
  ];
  // if (debug.DEBUG) {
  //   links.push({
  //     name: i18n.s('schema.enquiries'),
  //     collapsed: true,
  //     children: [
  //       {
  //         name: i18n.s('schema.enquiries'),
  //         path: '/admin/enquiries',
  //       },
  //       {
  //         name: i18n.s('schema.enquiry_questionnaires') + ' 1',
  //         path: '/admin/enquiry_questionnaires1',
  //       },
  //     ],
  //   });
  //   links = links.concat([
  //     {
  //       name: 'Dashboard',
  //       icon: 'ti-panel',
  //       collapsed: true,
  //       children: [
  //         {
  //           name: 'Overview',
  //           path: '/admin/overview',
  //         },
  //         {
  //           name: 'Stats',
  //           path: '/admin/stats',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Components',
  //       icon: 'ti-package',
  //       collapsed: true,
  //       children: [
  //         {
  //           name: 'Buttons',
  //           path: '/components/buttons',
  //         },
  //         {
  //           name: 'Grid System',
  //           path: '/components/grid-system',
  //         },
  //         {
  //           name: 'Panels',
  //           path: '/components/panels',
  //         },
  //         {
  //           name: 'Sweet Alert',
  //           path: '/components/sweet-alert',
  //         },
  //         {
  //           name: 'Notifications',
  //           path: '/components/notifications',
  //         },
  //         {
  //           name: 'Icons',
  //           path: '/components/icons',
  //         },
  //         {
  //           name: 'Typography',
  //           path: '/components/typography',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Forms',
  //       icon: 'ti-clipboard',
  //       collapsed: true,
  //       children: [{
  //         name: 'Regular Forms',
  //         path: '/forms/regular',
  //       },
  //         {
  //           name: 'Extended Forms',
  //           path: '/forms/extended',
  //         },
  //         {
  //           name: 'Validation Forms',
  //           path: '/forms/validation',
  //         },
  //         {
  //           name: 'Wizard',
  //           path: '/forms/wizard',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Table List',
  //       icon: 'ti-view-list-alt',
  //       collapsed: true,
  //       children: [{
  //         name: 'Regular Tables',
  //         path: '/table-list/regular',
  //       },
  //         {
  //           name: 'Extended Tables',
  //           path: '/table-list/extended',
  //         },
  //         {
  //           name: 'Paginated Tables',
  //           path: '/table-list/paginated',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Maps',
  //       icon: 'ti-map',
  //       collapsed: true,
  //       children: [{
  //         name: 'Google Maps',
  //         path: '/maps/google',
  //       },
  //         {
  //           name: 'Full Screen Maps',
  //           path: '/maps/full-screen',
  //         },
  //         {
  //           name: 'Vector Maps',
  //           path: '/maps/vector-map',
  //         },
  //       ],
  //     },
  //     {
  //       name: 'Charts',
  //       icon: 'ti-gift',
  //       path: '/charts',
  //     },
  //     {
  //       name: 'Calendar',
  //       icon: 'ti-calendar',
  //       path: '/calendar',
  //     },
  //     {
  //       name: 'Pages',
  //       icon: 'ti-gift',
  //       collapsed: true,
  //       children: [{
  //         name: 'User Page',
  //         path: '/pages/user',
  //       },
  //         {
  //           name: 'Timeline Page',
  //           path: '/pages/timeline',
  //         },
  //         {
  //           name: 'Login Page',
  //           path: '/login',
  //         },
  //         {
  //           name: 'Register Page',
  //           path: '/register',
  //         },
  //         {
  //           name: 'Lock Page',
  //           path: '/lock',
  //         },
  //       ],
  //     },
  //   ]);
  // }
  return links;
}



// WEBPACK FOOTER //
// ./src/sidebarLinks.js